export const ROLES = [
    'admin',
    'sales-us',
    'sales-ca',
    'products',
    'finances-(TODO)',
    'purchasing'
];
